require("jquery-validation");

$(document).ready(function () {
  const delay = 2e3;
  const form = $("#contact-us-form");
  const success = $("#successMessage");
  const failure = $("#failureMessage");

  form.validate({
    onsubmit: false,
    onkeyup: function (element) {
      $(element).valid();
    },
    rules: {
      SenderName: {
        required: true,
        maxlength: 100,
      },
      SenderEmail: {
        required: true,
        email: true,
        maxlength: 100,
      },
      Message: {
        required: true,
      },
    },
    messages: {
      SenderName: {
        required: "Please enter your name",
        maxlength: "Please enter a valid name",
      },
      SenderEmail: {
        required: "Please enter your email address",
        email: "Please enter a valid email address",
        maxlength: "Please enter a valid email address",
      },
      Message: {
        required: "Please enter your message",
      },
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element);
    },
  });

  function hideForm() {
    form.addClass("positioned").fadeOut();
  }

  success.exists(function () {
    hideForm();
    $(this).fadeIn().delay(delay).fadeOut();
    $("#promoMessage")
      .delay(delay + 1000)
      .fadeIn();
  });

  failure.exists(function () {
    hideForm();
    $(this).fadeIn().delay(delay).fadeOut();
    form.delay(delay + 1000).fadeIn();
  });
});
